import { Typography, Button, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { MultipleChoiceQuestionUIConfig } from '../../shared/MultipleChoiceQuestionUIConfig';
import { Answer } from '../../shared/VolunteerApplicationServiceTypes';
import { CheckCircleFilled } from '@ant-design/icons';

const { Text } = Typography;

export interface ApplicantAnswerToQuestionProps {
	uiConfig: MultipleChoiceQuestionUIConfig;
	value?: Answer;
	showBG?: boolean;
}

export const ApplicantAnswerToQuestion = ({
	uiConfig: { questionNo, questionText, answerOptions },
	value,
	showBG = false,
}: ApplicantAnswerToQuestionProps) => {
	const { t } = useTranslation();

	let answerOption;

	if (value) {
		answerOption =
			answerOptions &&
			answerOptions.find((option) => option.optionId === value.answerOptionId);
	}

	const answerText = answerOption ? t(answerOption.optionText) : '';

	return (
		<div
			className={`flex flex-row items-start rounded-md p-4 ${
				showBG ? 'bg-gray-100 border-solid border border-gray-200' : ''
			}`}
		>
			<Text className="mr-[8px] min-w-[12px] whitespace-nowrap">{`${questionNo}.`}</Text>
			<div className="flex flex-col w-full">
				<Text className="mb-[8px] font-sans font-bold text-sm text-black-100">
					{t(questionText)}
				</Text>
				{answerText && (
					<Button
						type="primary"
						className="bg-btn-blue h-fit text-gray-650 my-[8px] shadow-none hover:!bg-btn-blue hover:!text-gray-650 px-4 py-1.5 flex items-center gap-2 text-left"
					>
						<span className="text-primary-blue text-[22px] flex items-center">
							<CheckCircleFilled />
						</span>
						<span className="whitespace-normal break-words">{answerText}</span>
					</Button>
				)}
				{value?.additionalComment && (
					<div>
						<Input.TextArea
							className="font-sans font-normal text-sm"
							showCount
							rows={4}
							disabled
							value={value?.additionalComment}
						/>
					</div>
				)}
			</div>
		</div>
	);
};
